import placeholderImage from '@/assets/images/placeholder.jpg'

export const PlaceHolderImage = placeholderImage;

export const onErrorImage = (e) => {
    e.target.src = PlaceHolderImage
}
